class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function(evt){
      evt.preventDefault()

      // Close all drawers
      if (this.getAttribute('data-drawer') == 'all') {
        let activeDrawers = document.querySelectorAll('side-drawer.active');
        if (activeDrawers) {
          activeDrawers.forEach(el => {
            //Toggle drawer event
            const event = new Event('drawer-toggle');
            el.dispatchEvent(event);
          })
        }
      } else {
        let drawer = document.getElementById(this.getAttribute('data-drawer'));

        //Navigation
        //Check if need to close any open navigation drawers
        if (this.getAttribute('data-drawer').indexOf('drawer-navigation-') > -1) {
          let levelToToggle = this.getAttribute('data-drawer').split('drawer-navigation-')[1].split('-')[0];
          //Add class to navigation if level 3
          if (levelToToggle == '3') {
            document.querySelector('navigation').classList.add('level-3-active')
            this.classList.add('active')
            
            let navigationMain = this.parentNode.parentNode.parentNode.parentNode.parentNode;
            let activeMenuItem = this.textContent.trim();
            let linkedFeaturedItems = navigationMain.querySelectorAll('[data-drawer-link]');

            linkedFeaturedItems.forEach(el => {
              let linkedFeaturedValue = el.attributes[1].value;

              if (activeMenuItem == linkedFeaturedValue) {
                el.style.display = 'block';
              } else {
                el.style.display = 'none';
              }
            })
          }
  
          //Find other levels already open
          let openLevels = document.querySelectorAll('.navigation-level-'+levelToToggle);
          if (openLevels) {
            openLevels.forEach(el => {
              if (el != drawer) {
                el.classList.remove('active') 
              }
            })
          }
  
          let activeNavItems = document.querySelectorAll('.navigation-list__item.active');
          if (activeNavItems) {
            activeNavItems.forEach(item => {
              if (item != this) {
                item.classList.remove('active')
              }
            })
          }
        }
  
        //Toggle drawer event
        const event = new Event('drawer-toggle');
        drawer.dispatchEvent(event);
      }
    })
  }
}

customElements.define('side-drawer-toggle', SideDrawerToggle);
